import React, { useState, useEffect } from "react";
import "./Tabs.css";
import ContentRenderer from "./ContentRenderer";

const Tabs = ({ tabs, payload, selectedKey }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].key);

  const contentKey = selectedKey || "installation";

  console.log("selectedKey", selectedKey)

  return (
    <div className="tabs_wrapper">
      <div className="tab-titles">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`tab-title ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tab-content">
        {tabs.map((tab) =>
          activeTab === tab.key ? (
            <div key={tab.key} className="tab-pane">
              {payload[contentKey] && payload[contentKey][tab.key] ? (
                <ContentRenderer content={payload[contentKey][tab.key]} />
              ) : (
                <div>Select an option</div>
              )}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default Tabs;
